import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'

// Таб-фильтр списка: mono-подчёркивание (bg-полоса, не border-color: глобальный
// unlayered сброс `* { border-color }` бьёт border-утилиты). Подпись — узел, а не
// строка: табу бывает нужен индикатор рядом с именем (точка «здесь играет»).
export function FilterTab({
  active,
  onClick,
  children,
}: {
  active: boolean
  onClick: () => void
  children: ReactNode
}) {
  return (
    <button
      type="button"
      aria-pressed={active}
      onClick={onClick}
      className={cn(
        'relative pb-1.5 font-mono text-xs uppercase tracking-wide transition-colors',
        active ? 'text-text-primary' : 'text-text-tertiary hover:text-text-secondary',
      )}
    >
      {children}
      {active && (
        <span
          aria-hidden
          className="absolute inset-x-0 bottom-0 h-0.5 rounded-pill bg-text-primary"
        />
      )}
    </button>
  )
}
